var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingMoneyErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22699 10H9.78588C9.98537 9.99857 10.1815 9.94736 10.3571 9.85084C10.5328 9.75432 10.6826 9.61542 10.7935 9.44625C10.9044 9.27708 10.9731 9.08278 10.9936 8.88031C11.014 8.67784 10.9856 8.47334 10.9108 8.28465L6.57018 0.643569C6.46445 0.44858 6.30945 0.286048 6.1213 0.17287C5.93316 0.0596918 5.71873 0 5.50032 0C5.28191 0 5.06749 0.0596918 4.87934 0.17287C4.6912 0.286048 4.5362 0.44858 4.43046 0.643569L0.0898843 8.28465C0.0164865 8.46902 -0.0126187 8.66863 0.00499848 8.86682C0.0226157 9.065 0.0864442 9.25601 0.191155 9.4239C0.295866 9.59178 0.438421 9.73168 0.606918 9.8319C0.775416 9.93212 0.964966 9.98975 1.15974 10",
    fill: "#DE2248"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.5V5M5.5 7.99371V8.00001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingMoneyErrorIcon);
export default __webpack_public_path__ + "static/media/pending-money-error-icon.cddd0c0c697c06a18227b386c43e3b93.svg";
export { ForwardRef as ReactComponent };